<template>
<div id="contents">

  <div id="contact" class="page_contents">

    <div id="contact_contents">
      <div class="page_header">
        <h1 class="page_header_title">
          <img src="../assets/img/contact/title.png" width="323" alt="CONTACT" />
          <span>お問い合わせ</span>
        </h1><!-- .top_sec_title -->
      </div><!-- .page_header -->

      <div id="contact_contents_main" v-if="input_flg">
        <p class="contact_read">当社へのお問い合わせは、以下のフォームに記入の上、「ご記入内容確認へ」をクリックしてください。</p>

        <div id="contact_contents_box">
          <form id="js-form" class="clearfix" action="" method="post">
            <div id="contact_contents_box_inner">
              <div class="contact_box">
                <h3>お問い合わせになりたい内容<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <ul id="js-inquiry" class="inquiry_list">
  										<li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio required validate" name="inquiry" value="番組制作について" checked>
                          <span class="radio-icon"></span>
                          番組制作について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="イベント制作について">
                          <span class="radio-icon"></span>
                          イベント制作について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="PR動画について">
                          <span class="radio-icon"></span>
                          PR動画について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="コマーシャル（CM）制作について">
                          <span class="radio-icon"></span>
                          コマーシャル（CM）制作について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="ドローン事業について">
                          <span class="radio-icon"></span>
                          ドローン事業について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="撮影・編集について">
                          <span class="radio-icon"></span>
                          撮影・編集について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="MAGICについて">
                          <span class="radio-icon"></span>
                          MAGICについて
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="映像アーカイブについて">
                          <span class="radio-icon"></span>
                          映像アーカイブについて
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="個人情報について">
                          <span class="radio-icon"></span>
                          個人情報について
                        </label>
  										</li>
                      <li>
                        <label>
                          <input v-model="contact_obj.inquiry" type="radio" class="radio" name="inquiry" value="その他のお問い合わせ">
                          <span class="radio-icon"></span>
                          その他のお問い合わせ
                        </label>
  										</li>
  									</ul>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->


              <div class="contact_box">
                <h3>お名前<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.name" type="text" name="name" value="" class="validate required" id="name" placeholder="お名前を記入してください"  checked></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>所属<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <ul class="belongs_list">
  									<li>
                      <label>
                        <input v-model="contact_obj.belongs" type="radio" class="radio required validate" name="belongs" value="制作会社">
                        <span class="radio-icon"></span>
                        制作会社
                      </label>
                    </li>
                    <li>
                      <label>
                        <input v-model="contact_obj.belongs" type="radio" class="radio" name="belongs" value="個人・店舗">
                        <span class="radio-icon"></span>
                        個人・店舗
                      </label>
                    </li>
                    <li>
                      <label>
                        <input v-model="contact_obj.belongs" type="radio" class="radio" name="belongs" value="法人">
                        <span class="radio-icon"></span>
                        法人
                      </label>
                    </li>
                    <li>
                      <label>
                        <input v-model="contact_obj.belongs" type="radio" class="radio" name="belongs" value="団体等">
                        <span class="radio-icon"></span>
                        団体等
                      </label>
                    </li>
                    <li>
                      <label>
                        <input v-model="contact_obj.belongs" type="radio" class="radio" name="belongs" value="その他">
                        <span class="radio-icon"></span>
                        その他
                      </label>
                    </li>
  								</ul>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>会社名</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.company" type="text" name="company" value="" class="" id="company" placeholder="会社名を記入してください"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>部署・役職名</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.depart" type="text" name="depart" value="" class="" id="depart" placeholder="部署や役職名を記入してください"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>ご住所</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.address" type="text" name="address" value="" class="" id="address" placeholder="東京都港区六本木１丁目１−１"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>お電話番号</h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.tel" type="number" name="tel" value="" class="validate number" id="tel" placeholder=" 0335878111"  ></p>
                  <p class="read">※ハイフンはなしでご入力ください</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>メールアドレス<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.mail" type="mail" name="mail" value="" class="validate mail required" id="mail" placeholder=" abc@aaa.com"  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>お問い合わせの件名<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p><input v-model="contact_obj.body_title" type="text" name="body_title" value="" class="required validate" id="body_title" placeholder=""  ></p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box">
                <h3>お問い合わせの内容<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <textarea v-model="contact_obj.contact_body" name="contact_body" rows="8" cols="80" class="required validate" placeholder="具体的なお問い合わせ内容を記入してください"></textarea>
                  <p class="read contact_body_read">※必ずしも返信をお約束するものではありません。</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div id="form_btn_wrapper">
                <p class="form_btn long"><a v-on:click="form_check" class="btn btn-white long">ご記入内容の確認へ</a></p>
              </div><!-- #form_btn_wrapper -->

            </div><!-- #contact_contents_box_inner -->
          </form>

        </div><!-- #contact_contents_box -->
      </div><!-- #contact_contents_main -->

      <div id="contact_contents_main" v-else-if="send_flg == false && input_flg == false">
        <p class="contact_read">下記内容にて、送信致します。問題なければ「送信」をクリックしてください。</p>

        <div id="contact_contents_box">
          <form id="js-form" class="clearfix" action="" method="post">
            <div id="contact_contents_box_inner">
              <div class="contact_box" v-if="contact_obj.inquiry">
                <h3>お問い合わせになりたい内容<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <ul class="inquiry_list">
  										<li>
                        {{ contact_obj.inquiry }}
  										</li>
  									</ul>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->


              <div class="contact_box" v-if="contact_obj.name">
                <h3>お名前<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.name }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.belongs">
                <h3>所属<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <ul class="belongs_list">
  									<li>
                      {{ contact_obj.belongs }}
                    </li>
  								</ul>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.company">
                <h3>会社名</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.company }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.depart">
                <h3>部署・役職名</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.depart }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.address">
                <h3>ご住所</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.address }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.tel">
                <h3>お電話番号</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.tel }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.mail">
                <h3>メールアドレス</h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.mail }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.body_title">
                <h3>お問い合わせの件名<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.body_title }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div class="contact_box" v-if="contact_obj.contact_body">
                <h3>お問い合わせの内容<span>（必須）</span></h3>
                <div class="contact_box_inner">
                  <p>{{ contact_obj.contact_body }}</p>
                </div><!-- .contact_box_inner -->
              </div><!-- .contact_box -->

              <div id="form_btn_wrapper" class="form_btn_wrapper_check">
                <p class="form_btn"><a v-on:click="backinput" class="btn btn-white">修正</a></p>

                <p class="form_btn"><a v-on:click="mail_send" class="btn btn-white">送信</a></p>
              </div><!-- #form_btn_wrapper -->

            </div><!-- #contact_contents_box_inner -->
          </form>

        </div><!-- #contact_contents_box -->

      </div><!-- #contact_contents_main -->

      <div id="contact_contents_main" v-else-if="send_flg == true && input_flg == false">
        <p class="contact_read">お問い合わせをありがとうございます。送信を完了致しました。<br /><router-link to="/">TOPへ戻る</router-link></p>
      </div><!-- #contact_contents_main -->


    </div><!-- #contact_contents -->
  </div><!-- #contact -->



</div><!-- #contents -->
</template>

<script>
export default {
  name: 'contact',
  data(){
    return {
      api_url: this.$parent.api_base_url+'/api/contact/send_mail.php',
      contact_obj: {
        inquiry: '',
        name: '',
        belongs: '',
        company: '',
        depart: '',
        address: '',
        tel: '',
        mail: '',
        body_title: '',
        contact_body: '',
        token: '',
        headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Access-Control-Allow-Origin': '*',
        }
      },
      input_flg: true,
      send_flg: false,
      referrer: this.$attrs.referrer,
      errors: []
    }
  },
  methods: {
    backinput: function(e){
      this.input_flg = true
      return false
    },
    form_check: function(e){
      $("span.error").remove();
      $("contact_box_inner").removeClass("error");

      $(":text,[type='number'],[type='mail'],textarea").filter(".validate").each(function(){
          //必須項目のチェック
          $(this).filter(".required").each(function(){
            if($(this).val()==""){
              $(this).parent().prepend("<span class='error'>※必須項目です</span>")
            }
          })

          //数値のチェック
          $(this).filter(".number").each(function(){
            if(isNaN($(this).val())){
              $(this).parent().prepend("<span class='error'>数値のみ入力可能です</span>")
            }
          })

          //メールアドレスのチェック
          $(this).filter(".mail").each(function(){
            if($(this).val() && !$(this).val().match(/.+@.+\..+/g)){
              $(this).parent().prepend("<span class='error'>メールアドレスの形式が異なります</span>")
            }
          })
      });

      //ラジオボタンのチェック
      $(":radio").filter(".validate").each(function(){
        $(this).filter(".required").each(function(){
          if($("input[name="+$(this).attr("name")+"]:checked").length == 0){
            $(this).closest('.contact_box_inner').prepend("<span class='error'>※選択してください</span>")
          }
        })
      })

      //エラーの際の処理
      if($("span.error").length > 0){
        $('html,body').animate({ scrollTop: $("span.error:first").offset().top-40 }, 'slow');
        $("span.error").closest('.contact_box_inner').addClass("error");
      }else{
        this.input_flg = false
        $('html,body').animate({ scrollTop: $("#contact_contents").offset().top }, 'slow')
      }
      return false;
    },
    mail_send: function(){
      this.$axios
        .post(this.api_url,{
          inquiry: this.contact_obj.inquiry,
          name: this.contact_obj.name,
          belongs: this.contact_obj.belongs,
          company: this.contact_obj.company,
          depart: this.contact_obj.depart,
          address: this.contact_obj.address,
          tel: this.contact_obj.tel,
          mail: this.contact_obj.mail,
          body_title: this.contact_obj.body_title,
          contact_body: this.contact_obj.contact_body,
          token: 'vivia'
        },this.header)
        .then(response => {
          console.log('hoge')
          console.log(response)
          if(response.data.response.header.status == 'success'){
            this.send_flg = true
            $('html,body').animate({ scrollTop: $("#contact_contents").offset().top }, 'slow')
          }else{
            alert('送信に失敗しました')
            this.send_flg = false
          }
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
      return false
    }
  },
  mounted () {

    const ts = this
    setTimeout(function(){
      ts.$emit('page_fade')
    },ts.$parent.page_load_time)

    //form
    // $("#js-form").submit(function(e){

    //   $("span.error").remove();
    //   $("contact_box_inner").removeClass("error");

    //   $(":text,[type='number'],[type='mail'],textarea").filter(".validate").each(function(){
    //       //必須項目のチェック
    //       $(this).filter(".required").each(function(){
    //         if($(this).val()==""){
    //           $(this).parent().prepend("<span class='error'>※必須項目です</span>")
    //         }
    //       })

    //       //数値のチェック
    //       $(this).filter(".number").each(function(){
    //         if(isNaN($(this).val())){
    //           $(this).parent().prepend("<span class='error'>数値のみ入力可能です</span>")
    //         }
    //       })

    //       //メールアドレスのチェック
    //       $(this).filter(".mail").each(function(){
    //         if($(this).val() && !$(this).val().match(/.+@.+\..+/g)){
    //           $(this).parent().prepend("<span class='error'>メールアドレスの形式が異なります</span>")
    //         }
    //       })
    //   });

    //   //ラジオボタンのチェック
    //   $(":radio").filter(".validate").each(function(){
    //     $(this).filter(".required").each(function(){
    //       if($("input[name="+$(this).attr("name")+"]:checked").length == 0){
    //         $(this).closest('.contact_box_inner').prepend("<span class='error'>※選択してください</span>")
    //       }
    //     })
    //   })

    //   //エラーの際の処理
    //   if($("span.error").length > 0){
    //     $('html,body').animate({ scrollTop: $("span.error:first").offset().top-40 }, 'slow');
    //     $("span.error").closest('.contact_box_inner').addClass("error");
    //   }else{
    //     ts.input_flg = false
    //     $('html,body').animate({ scrollTop: $("#contact_contents").offset().top }, 'slow')
    //   }
    //   return false;
    // });

    //リファラーによって、チェック
    if(this.$attrs.referrer){
      $('input[name=inquiry]').val([this.$attrs.referrer]);
      this.contact_obj.inquiry = this.$attrs.referrer
    }

  }
}
</script>

<style scoped>
















</style>



// WEBPACK FOOTER //
// src/components/contact.vue